import React from 'react'
import { ThemeProvider } from 'styled-components'

import '../styles/global.scss'

// Extract SASS variables into JS object
const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!./../styles/_variables.scss')

export default function RootLayout({ children }) {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
